import React from 'react';

import BasicBar from '../../containers/app_bars/basic_bar';
import BasicCard from '../../containers/cards/basic_card';
import LoginForm from './login_form';
import Grid from '@mui/material/Grid';

const PrivateLogin = () => {
    return (
        <Grid container spacing={1} >            
            <BasicBar />
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%'}}>
            <Grid item xs={12} md={6} >
                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                <BasicCard
                    width={'90%'}
                    title={''}
                    content={
                        <LoginForm />
                    }
                    buttons={
                        <></>
                    }
                />
                </div>
            </Grid>
            </div>
            
        </Grid>
    );
}

export default PrivateLogin;
